<div class="user-info-wrapper">
  <img src="/assets/img/user-avatar-placeholder.svg" alt="Zdjęcie użytkownika" />
  <p class="user-info-name">{{ username }}</p>
  <p class="user-info-position">{{ role }}</p>
  <p class="user-info-company" *appHasRole="[Roles.Agent, Roles.Auditor, Roles.AuditorVerifier, Roles.Verifier]">{{ companyName }}</p>
</div>
